import {PriceVisibilityType} from "../../vendor/types/PriceVisibilityType";
import {IApplication} from "../types/IApplication";

export const shouldApplicationPriceBeenShownVariantBCD = (application?: IApplication | null) => {
    return Boolean(
        application?.price_visibility && [PriceVisibilityType.ALWAYS, PriceVisibilityType.AUTO].includes(application.price_visibility) && application.show_price
    );
};
import {PriceVisibilityType} from "../../vendor/types/PriceVisibilityType";
import {IApplication} from "../types/IApplication";

export const shouldApplicationPriceBeenShownVariantBCD = (application?: IApplication | null) => {
    return Boolean(
        application?.price_visibility && [PriceVisibilityType.ALWAYS, PriceVisibilityType.AUTO].includes(application.price_visibility) && application.show_price
    );
};
